import { render, staticRenderFns } from "./AreaList_details.vue?vue&type=template&id=1ea48d4e&scoped=true&"
import script from "./AreaList_details.vue?vue&type=script&lang=js&"
export * from "./AreaList_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea48d4e",
  null
  
)

export default component.exports